import { z } from 'zod';

/** Mirrors AdminPurchaseLimitService validation; the backend re-checks every rule. */
export const purchaseLimitSchema = z
  .object({
    metric: z.enum(['OrderValue', 'OrderCount']),
    maxAmount: z.number().positive('Enter a limit above zero.'),
    periodDays: z
      .number()
      .int('Whole days only.')
      .min(1, 'At least 1 day.')
      .max(366, 'At most 366 days.'),
    reason: z
      .string()
      .refine((value) => value.trim().length >= 5, 'Give a reason (5+ characters).'),
  })
  .refine((values) => values.metric !== 'OrderCount' || Number.isInteger(values.maxAmount), {
    path: ['maxAmount'],
    message: 'A number of orders must be a whole number.',
  });

export type PurchaseLimitFormValues = z.infer<typeof purchaseLimitSchema>;
